import yup from "./yup";

export const forgotPasswordSchema = yup.object().shape({
    UserName: yup.string(),
    Token: yup.string(),
    NewPassword:
        yup.string().min(6)
            .label('Nueva contraseña')
            .required(),
    passwordConfirm:
        yup.string().label('Confirmar contraseña')
            .oneOf([yup.ref('NewPassword'), null], "Las Contraseñas no coinciden")
            .required(),
});